var _jsxFileName = "/repo/packages/webassets/src/components/CaptiveWindow/CaptiveWindow.tsx",
  _this = this;
import React from 'react';
import { Card } from '@sm/wds-react';
import { LogoWithText } from '../Logos';
import './captive-window.scss';
import Footer from './Footer';
var CaptiveWindow = function CaptiveWindow(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "sm-captive-window__page wds-flex wds-flex--y wds-flex--x-center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "sm-captive-window__section",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("header", {
    className: "sm-logo__header",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(LogoWithText, {
    className: "sm-logo__logo",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Card, Object.assign({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 7
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sm-captive-window__section",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Footer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  })));
};
export default CaptiveWindow;
//# sourceMappingURL=CaptiveWindow.js.map